module.exports = __webpack_public_path__ + "static/media/lumenlife-4.1f1f3a0b.jpg";